import React from "react";
import { MailOutlined, WhatsAppOutlined } from "@ant-design/icons";

export const ValidationCard = ({ card }) => (
  <div className="tw-rounded-2xl tw-border tw-border-solid tw-border-slate-100 tw-bg-white tw-p-5 tw-shadow-[0_10px_30px_rgba(0,0,0,0.02)] hover:tw-shadow-[0_12px_24px_rgba(15,23,42,0.04)] tw-transition-all tw-duration-300">
    <div
      className={`tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-xl tw-text-[15px] tw-shadow-sm ${card.iconWrapClass}`}
    >
      {card.icon}
    </div>
    <div className="tw-mt-6 tw-text-[10px] tw-font-bold tw-text-slate-400 tw-uppercase tw-tracking-wider tw-font-poppins">{card.label}</div>
    <div className="tw-mt-1.5 tw-flex tw-items-end tw-gap-2">
      <div className="tw-text-[24px] tw-font-bold tw-leading-none tw-text-slate-800 tw-font-poppins">
        {card.value}
      </div>
      {card.details && (
        <div className="tw-text-[12px] tw-font-semibold tw-text-slate-400 tw-mb-0.5 tw-font-inter">
          ({card.details})
        </div>
      )}
    </div>
    <div className="tw-mt-5 tw-h-[4px] tw-rounded-full tw-bg-[#E8E1FF]">
      <div
        className={`tw-h-full tw-rounded-full ${card.progressClass}`}
        style={{ width: card.progressWidth || "0%" }}
      />
    </div>
  </div>
);

export const DetailStatCard = ({
  icon,
  iconWrapClass,
  label,
  value,
  progressWidth,
  progressClass = "tw-bg-[#5D44FF]",
  progressTrackClass = "tw-bg-[#E8E1FF]",
}) => (
  <div className="tw-rounded-2xl tw-border tw-border-solid tw-border-slate-100 tw-bg-white tw-p-5 tw-shadow-[0_10px_30px_rgba(0,0,0,0.02)] hover:tw-shadow-[0_12px_24px_rgba(15,23,42,0.04)] tw-transition-all tw-duration-300">
    <div className={`tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-xl tw-text-[15px] tw-shadow-sm ${iconWrapClass}`}>
      {icon}
    </div>
    <div className="tw-mt-6 tw-text-[10px] tw-font-bold tw-text-slate-400 tw-uppercase tw-tracking-wider tw-font-poppins">{label}</div>
    <div className="tw-mt-1.5 tw-text-[24px] tw-font-bold tw-leading-none tw-text-slate-800 tw-font-poppins">
      {value}
    </div>
    <div className={`tw-mt-5 tw-h-[4px] tw-rounded-full ${progressTrackClass}`}>
      <div
        className={`tw-h-full tw-rounded-full ${progressClass}`}
        style={{ width: progressWidth || "0%" }}
      />
    </div>
  </div>
);

export const ChannelBadge = ({ type }) => {
  if (type === "whatsapp") {
    return (
      <span className="tw-inline-flex tw-items-center tw-gap-1.5 tw-rounded-full tw-bg-[#EAFBF0] tw-px-3 tw-py-1 tw-text-[11.5px] tw-font-semibold tw-text-[#22C55E] tw-border tw-border-solid tw-border-[#D2F7DC]">
        <WhatsAppOutlined />
        WhatsApp
      </span>
    );
  }

  return (
    <span className="tw-inline-flex tw-items-center tw-gap-1.5 tw-rounded-full tw-bg-[#EBE8FD] tw-px-3 tw-py-1 tw-text-[11.5px] tw-font-semibold tw-text-[#5D44FF] tw-border tw-border-solid tw-border-[#D9D3FF]">
      <MailOutlined />
      Email
    </span>
  );
};
